import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Tooltip } from '../../tooltip/tooltip';

interface FairPriceTabLabelProps {
    labelKey: string;
    tooltipKey: string;
    showSmall?: boolean;
}

export const FairPriceTabLabel: React.FC<FairPriceTabLabelProps> = ({ labelKey, tooltipKey, showSmall = false }) => {
    const { t } = useTranslation();

    return (
        <span className="inline-flex items-center gap-xsmall">
            <Tooltip
                icon
                position="bottom-right"
                content={
                    <Trans
                        i18nKey={tooltipKey}
                        components={
                            showSmall
                                ? { br: <br />, strong: <strong />, small: <small /> }
                                : { br: <br />, strong: <strong /> }
                        }
                    />
                }
            >
                {t(labelKey)}
            </Tooltip>
        </span>
    );
};
